(() => {
  // app/scripts/common/component/details.js
  !window.customElements.get("accordion-component") && window.customElements.define("accordion-component", class extends HTMLElement {
    constructor() {
      super();
      if (this.hasAttribute("data-open-screen") || this.hasAttribute("data-close-screen")) {
        const { debounceTime } = theme;
        this.debounce = debounceTime(this.changeState.bind(this), 300);
        window.addEventListener("resize", this.debounce);
      }
      this.querySelectorAll("summary a").forEach((link) => {
        link.addEventListener("click", (e) => {
          e.stopPropagation();
        });
      });
      this.changeState();
      setTimeout(() => {
        this.querySelector("details") && this.init();
      }, 0);
    }
    connectedCallback() {
      this.observeClassChanges();
    }
    disconnectedCallback() {
      if (this.hasAttribute("data-open-screen") || this.hasAttribute("data-close-screen")) {
        window.removeEventListener("resize", this.debounce);
      }
      this.attributeObserver?.disconnect();
    }
    observeClassChanges() {
      const toggleEls = document.querySelectorAll(".jsToggleClass");
      const hasTrigger = [...toggleEls].find((el) => {
        const target = el.dataset.target;
        if (!target.includes(".")) return false;
        const elmsInDOM = document.querySelectorAll(target);
        const isExist = [...elmsInDOM].find((elm) => elm == this);
        return !!isExist;
      });
      if (!hasTrigger) return;
      this.attributeObserver = new MutationObserver((mutationList, observer) => {
        const details = this.querySelector("details");
        if (!details) return;
        details.querySelector("summary")?.click();
      });
      this.attributeObserver.observe(this, { attributes: true, attributeFilter: ["class"] });
    }
    init() {
      this.details = this.querySelector("details");
      this.summary = this.details.querySelector(":scope > summary");
      this.content = this.details.querySelector(":scope > *:not(summary)");
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener("click", (e) => this.onClick(e));
      this.details.classList.add("accordion-initialized");
    }
    onClick(e) {
      e.preventDefault();
      this.details.style.overflow = "hidden";
      this.onCloseAccordionDifferent();
      if (this.isClosing || !this.details.open) {
        this.open();
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      this.isClosing = true;
      const summaryPosition = window.getComputedStyle(this.summary).position;
      const startHeight = `${this.details.offsetHeight}px`;
      const styles = window.getComputedStyle(this.details);
      const paddingTop = styles.getPropertyValue("padding-top");
      const paddingBottom = styles.getPropertyValue("padding-bottom");
      const paddingTopValue = parseFloat(paddingTop);
      const paddingBottomValue = parseFloat(paddingBottom);
      const endHeight = `${summaryPosition == "absolute" ? 0 : this.summary.offsetHeight + paddingTopValue + paddingBottomValue}px`;
      if (this.animation) {
        this.animation.cancel();
      }
      this.details.classList.add("is-closing");
      this.animation = this.details.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: "ease-out"
      });
      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }
    open() {
      this.details.style.height = `${this.details.offsetHeight}px`;
      this.details.open = true;
      this.details.classList.add("is-opening");
      window.requestAnimationFrame(() => this.expand());
    }
    expand() {
      this.isExpanding = true;
      const summaryPosition = window.getComputedStyle(this.summary).position;
      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${summaryPosition == "absolute" ? this.content.offsetHeight : this.details.scrollHeight}px`;
      if (this.animation) {
        this.animation.cancel();
      }
      const s = Math.abs(+startHeight.replace("px", "") - endHeight.replace("px", ""));
      const v = s / 50;
      this.animation = this.details.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        //v*100,
        easing: "ease-out"
      });
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }
    onAnimationFinish(open) {
      this.details.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.details.classList.remove("is-closing", "is-opening");
      this.details.style.height = this.details.style.overflow = "";
    }
    changeState() {
      this.hasAttribute("data-open-screen") && window.matchMedia(this.getAttribute("data-open-screen")).matches && (this.querySelector("details").open = true);
      this.hasAttribute("data-close-screen") && window.matchMedia(this.getAttribute("data-close-screen")).matches && (this.querySelector("details").open = false);
    }
    onCloseAccordionDifferent() {
      const group = this.closest(".group-accordion");
      if (!group) return;
      group.querySelectorAll("accordion-component details[open]").forEach((details) => {
        if (details !== this.details) {
          const accordion = details.closest("accordion-component");
          accordion.shrink();
        }
      });
    }
  });
})();
